<template>
  <b-container class="custom-container p-0 py-5">
    <!-- Shimmer Effect -->
    <b-row class="pt-5 mt-5" v-if="loading">
      <b-col v-for="i in 3" :key="i">
        <card-shimmer
          :imageHead="true"
          :withTitle="true"
          imageHeadHeight="250px"
        ></card-shimmer>
      </b-col>
    </b-row>

    <div v-else>
      <div class="text-center" v-if="savedJobs.length === 0">
        <div class="page-title pt-5 mb-4">Oops!</div>
        <div class="font-weight-bold mb-4">
          Looks like you didn’t save any jobs.
          <br />Jobs you save will be displayed here.
        </div>
        <div>
          <b-button
            class="mb-3"
            variant="primary"
            :to="{ name: 'job.feed-page' }"
            >Browse Jobs</b-button
          >
        </div>
        <div>
          <b-img
            class="mb-5"
            fluid
            :src="require('@/assets/icons/no-jobs.svg')"
          ></b-img>
        </div>
      </div>
      <div v-else>
        <div class="page-title pt-5 mb-4">Saved Jobs</div>
        <job-list :jobs="savedJobs" />
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import JobList from '@/components/lists/JobList'
import CardShimmer from '@/components/shimmers/card'
import debounce from 'lodash/debounce'

export default {
  components: {
    JobList,
    CardShimmer
  },

  computed: {
    ...mapState({
      savedJobs: state => state.job.list,
      savedJobsMeta: state => state.job.listMeta
    })
  },

  data() {
    return {
      loading: false
    }
  },

  methods: {
    ...mapActions({
      getJobs: 'job/getJobs'
    }),

    ...mapMutations({
      clearJobs: 'job/clearJobList'
    }),

    handleScroll(e) {
      const docEl = document.documentElement
      if (docEl.scrollTop + window.innerHeight === docEl.scrollHeight) {
        this.loadMoreSavedJobs()
      }
    },

    loadMoreSavedJobs() {
      if (this.savedJobsMeta.current_page < this.savedJobsMeta.last_page) {
        this.fetchSavedJobs(this.savedJobsMeta.current_page + 1)
      }
    },

    async fetchSavedJobs(page = 1) {
      if (this.loading) return
      const params = {
        page: page,
        limit: 6,
        only_favorited: true
      }
      this.loading = true
      await this.getJobs(params)
      this.loading = false
    }
  },

  created() {
    this.clearJobs()
    this.fetchSavedJobs()

    this.handleDebouncedScroll = debounce(this.handleScroll, 100)
    window.addEventListener('scroll', this.handleDebouncedScroll)
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleDebouncedScroll)
  }
}
</script>

<style lang="scss" scoped>
.btn {
  padding: 14px 50px;
}
</style>
